import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ESTABLISHED_TIER_LEVEL, tierByLevel } from '../core/domain/tiers';

/**
 * Badge de palier affiché publiquement sur la fiche du producteur.
 *
 * Il porte le titre de la grille des 10 paliers et non le numéro : « Artisan
 * Reconnu » parle au client, « palier 6 » ne parle qu'à nous.
 *
 * Les trois premiers paliers s'affichent en gris plutôt qu'en vert. Le dossier
 * fait du palier 4 le seuil où le producteur devient « Établi » et débloque les
 * outils de gestion : la distinction visuelle rend donc la progression lisible
 * côté client autant que côté producteur.
 */
@Component({
  selector: 'ct-tier-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (title(); as label) {
      <span class="badge" [class.muted]="muted()">{{ label }}</span>
    }
  `,
  styles: `
    .badge {
      display: inline-block;
      font-size: 0.625rem;
      font-weight: var(--ct-weight-bold);
      line-height: 1.4;
      padding: 3px 9px;
      border-radius: var(--ct-radius-pill);
      background: var(--ct-vert-cageot);
      color: var(--ct-text-on-green);
      white-space: nowrap;
    }

    .muted {
      background: var(--ct-neutral);
      color: var(--ct-text-muted);
    }
  `,
})
export class CtTierBadge {
  /** Rang de 1 à 10 dans la grille des paliers. */
  readonly level = input.required<number>();

  protected readonly title = computed(() => tierByLevel(this.level())?.title);

  protected readonly muted = computed(() => this.level() < ESTABLISHED_TIER_LEVEL);
}
